/* ======================================================================
   BUNDLE BAR LOGIC – Sextember (variant-aware, scoped, B2G1 supported)
   Modes:
     - 'b2g1'       -> Buy 2 Get 1 Free (free = cheapest)
     - 'fixed_price'-> Buy N @ ₹X (optional fallback)
   Totals use paise. Variant clicks are capture-phase to avoid global conflicts.
   ====================================================================== */

   (function () {
    document.addEventListener('DOMContentLoaded', () => {
      const bar = document.getElementById('bundleBar');
      if (!bar) return;
  
      // Offer params
      const MODE = (bar.dataset.offerType || 'b2g1'); // 'b2g1' | 'fixed_price'
      const MAX_ITEMS = parseInt(bar.dataset.bundleSize, 10) || 3;
  
      // Fixed-price only (ignored in b2g1)
      const OFFER_PRICE_STRING = bar.dataset.bundlePrice || '999';
      const OFFER_PRICE_INT = parseInt(OFFER_PRICE_STRING.replace(/[,₹\s]/g, '')) * 100;
  
      // DOM refs
      const progressEl = bar.querySelector('[data-bundle-progress]');
      const totalEl = bar.querySelector('[data-bundle-total]');
      const nextBtn = bar.querySelector('[data-bundle-next]');
      const slots = bar.querySelectorAll('.bundle-slot');
      const plusIcons = bar.querySelectorAll('.bundle-plus');
  
      // State
      const bundle = []; // [{id, price, title, img}]
  
      // Helpers
      const formatMoney = (p) => `₹${(p / 100).toFixed(2)}`;
      const cardBtnFor = (id) =>
        document.querySelector(`.product-card--sextember .bundle-add-btn[data-variant-id="${id}"]`);
  
      const BTN_ADD = '<span class="btn-fill" data-fill></span><span class="btn-text">Add&nbsp;to&nbsp;box</span>';
      const BTN_DONE = '<span class="btn-text">Added</span>';
  
      function cheapestPrice(items) {
        if (!items.length) return 0;
        return items.reduce((min, itm) => Math.min(min, Number(itm.price) || 0), Number(items[0].price) || 0);
      }
  
      function renderBundle() {
        bar.classList.toggle('hidden', bundle.length === 0);
  
        // Slots
        slots.forEach((slot, i) => {
          const item = bundle[i];
          if (item) {
            slot.innerHTML =
              `<img src="${item.img}" alt="${item.title}" class="w-full h-full object-cover rounded" />
               <button type="button" class="bundle-remove absolute top-0 right-0 text-sm p-px" aria-label="Remove">×</button>`;
            slot.dataset.variantId = item.id;
            slot.classList.remove('border-dashed', 'text-gray-400');
            slot.classList.add('relative');
          } else {
            slot.textContent = 'ADD';
            delete slot.dataset.variantId;
            slot.classList.add('border-dashed', 'text-gray-400');
            slot.classList.remove('relative');
          }
        });
  
        // Totals / progress
        const subtotal = bundle.reduce((sum, itm) => sum + (Number(itm.price) || 0), 0);
        const remaining = Math.max(0, MAX_ITEMS - bundle.length);
  
        if (bundle.length < MAX_ITEMS) {
          totalEl.innerHTML = `Total ${formatMoney(subtotal)}`;
          if (MODE === 'b2g1') {
            progressEl.textContent = `Add ${remaining} more to unlock “Buy 2 Get 1 Free”`;
          } else {
            progressEl.textContent = `Add ${remaining} more to get the bundle at ${OFFER_PRICE_STRING}`;
          }
        } else {
          if (MODE === 'b2g1') {
            const freeAmt = cheapestPrice(bundle);
            const estTotal = subtotal - freeAmt;
            totalEl.innerHTML = `Est. total ${formatMoney(estTotal)} <s class="opacity-60 ml-1">${formatMoney(subtotal)}</s>`;
            progressEl.textContent = `Eligible! Cheapest item will be free at cart.`;
          } else {
            totalEl.innerHTML = `Total ${formatMoney(OFFER_PRICE_INT)} <s class="opacity-60 ml-1">${formatMoney(subtotal)}</s>`;
            progressEl.textContent = `Can't add more products`;
          }
        }
  
        plusIcons.forEach((p) => {
          p.style.visibility = bundle.length === MAX_ITEMS ? 'hidden' : 'visible';
        });
        nextBtn.disabled = bundle.length !== MAX_ITEMS;
        nextBtn.textContent = bundle.length === MAX_ITEMS ? 'Add to cart' : 'Next';
      }
  
      function addButtonListeners(scope = document) {
        scope.querySelectorAll('.product-card--sextember .bundle-add-btn').forEach((btn) => {
          if (btn.__sextemberBound) return;
          btn.__sextemberBound = true;
  
          btn.addEventListener('click', () => {
            const id = btn.dataset.variantId;
            const pricePaiseRaw = btn.dataset.productPrice ?? btn.dataset.priceRaw;
            const price = parseInt(String(pricePaiseRaw), 10);
            if (!id || !price || bundle.length >= MAX_ITEMS) return;
            if (bundle.some((itm) => itm.id === id)) return;
  
            bundle.push({
              id,
              price,
              title: btn.dataset.productTitle || btn.dataset.variantTitle || '',
              img: btn.dataset.productImg || '',
            });
  
            btn.classList.add('opacity-50', 'pointer-events-none');
            btn.innerHTML = BTN_DONE;
            renderBundle();
          });
        });
      }
  
      function refreshCardAddButtonFromVariantBtn(variantBtn) {
        const card = variantBtn.closest('.product-card--sextember');
        if (!card) return;
  
        const newId = variantBtn.dataset.variantId;
        const newPricePaise = variantBtn.dataset.priceRaw || '';
        const newImg = variantBtn.dataset.image || '';
        const newPriceFormatted = variantBtn.dataset.priceFormatted || '';
  
        card.setAttribute('data-selected-variant-id', newId);
        const addBtn = card.querySelector('.bundle-add-btn');
        if (addBtn) {
          addBtn.dataset.variantId = newId;
          addBtn.dataset.productPrice = newPricePaise;
          addBtn.dataset.priceRaw = newPricePaise;
          if (newImg) addBtn.dataset.productImg = newImg;
          const variantTitle = variantBtn.textContent && variantBtn.textContent.trim();
          if (variantTitle) addBtn.dataset.variantTitle = variantTitle;
        }
  
        const priceBox = card.querySelector('[data-price-container]');
        if (priceBox) {
          const price = priceBox.querySelector('[data-price]');
          const mrp = priceBox.querySelector('[data-compare]');
          const disc = priceBox.querySelector('[data-discount]');
  
          if (price && newPriceFormatted) price.textContent = newPriceFormatted;
  
          const isOnSale = variantBtn.dataset.onsale === 'true';
          if (mrp) {
            mrp.classList.toggle('hidden', !isOnSale);
            if (isOnSale && variantBtn.dataset.compareFormatted) {
              mrp.textContent = variantBtn.dataset.compareFormatted;
            }
          }
          if (disc) {
            disc.classList.toggle('hidden', !isOnSale);
            if (isOnSale && variantBtn.dataset.discount) {
              disc.textContent = `${variantBtn.dataset.discount}% OFF`;
            }
          }
          priceBox.classList.toggle('price--on-sale', isOnSale);
        }
      }
  
      // Capture-phase handler so global .variant-btn listeners don't fire on Sextember cards
      document.addEventListener(
        'click',
        (e) => {
          const btn = e.target.closest('.product-card--sextember .variant-btn');
          if (!btn) return;
  
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
  
          const card = btn.closest('.product-card--sextember');
          if (!card) return;
  
          card.querySelectorAll('.variant-btn').forEach((b) => b.classList.toggle('is-active', b === btn));
  
          const hiddenInput = card.querySelector('input[name="id"]');
          if (hiddenInput) hiddenInput.value = btn.dataset.variantId;
  
          if (btn.dataset.image) {
            const mediaContainer = card.querySelector('.product-card__media');
            if (mediaContainer) {
              const images = mediaContainer.querySelectorAll('img:not([data-ignore-swap])');
              images.forEach((img) => {
                const imgClasses = img.className;
                const imgDataset = { ...img.dataset };
                const newImg = new Image();
                newImg.src = btn.dataset.image;
                newImg.className = imgClasses;
                newImg.alt = img.alt || '';
                Object.keys(imgDataset).forEach((key) => (newImg.dataset[key] = imgDataset[key]));
                img.parentNode.replaceChild(newImg, img);
              });
            }
          }
  
          refreshCardAddButtonFromVariantBtn(btn);
        },
        true
      );
  
      // Remove from bundle
      bar.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('.bundle-remove');
        if (!removeBtn) return;
  
        const slot = removeBtn.closest('.bundle-slot');
        const id = slot && slot.dataset.variantId;
        if (!id) return;
  
        const cardBtn = cardBtnFor(id);
        if (cardBtn) {
          cardBtn.classList.remove('opacity-50', 'pointer-events-none');
          cardBtn.innerHTML = BTN_ADD;
        }
  
        const idx = bundle.findIndex((itm) => itm.id === id);
        if (idx > -1) bundle.splice(idx, 1);
        renderBundle();
      });
  
      // Add to cart (B2G1 discount applies automatically in cart)
      nextBtn.addEventListener('click', async () => {
        if (bundle.length !== MAX_ITEMS) return;
        nextBtn.disabled = true;
        try {
          const body = { items: bundle.map((itm) => ({ id: itm.id, quantity: 1 })) };
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
          });
          if (!res.ok) throw new Error(res.status);
          bundle.length = 0;
          renderBundle();
          // window.location.href = '/cart'; // optional
        } catch (e) {
          console.error(e);
          alert('Sorry, something went wrong adding your bundle.');
        } finally {
          nextBtn.disabled = false;
        }
      });
  
      addButtonListeners(document);
      renderBundle();
    });
  })();
  